import { FlowClient } from '@@api';
import { EntityMetadataModel } from '../../../api/api';
import { SchemaRefModel } from '../Models/DomainServiceModel';

export interface IEntitySchemaRepository {
	getEntity(schemaRef: SchemaRefModel): Promise<EntityMetadataModel | undefined>;
}

export class EntitySchemaRepository implements IEntitySchemaRepository {
	private cache: Record<string, EntityMetadataModel> = {};

	constructor(private flowClient: FlowClient) {}

	async getEntity(schemaRef: SchemaRefModel): Promise<EntityMetadataModel | undefined> {
		if (this.cache[schemaRef.Id]) {
			return this.cache[schemaRef.Id];
		}

		const entityModel = await this.flowClient.getEntityById(schemaRef.ContextId, schemaRef.Id, true);

		this.cache[schemaRef.Id] = entityModel;

		// ToDo: Fetch nested entities and properties
		// for (const prop of entityModel.properties.filter(
		//   (p) => !!p.referenceEntityId
		// )) {
		// }

		return entityModel;
	}
}
